import actiontypes from '../actiontypes'
import { Storage } from 'common-tools/StorageHelper'
import _ from 'common-tools/LodashHelper'
import { AuthAccountInfo } from 'common-classes/AuthAccountInfo'

const CookieName = 'Hive'
let actions = {}

actions[actiontypes.CurrentSession.SetAccount] = (state, action) => {
  let newState = _.merge({}, state)
  newState.Token = action.payload.token
  Storage.Save(`${CookieName}Token`, action.payload.token)
  newState.Account = new AuthAccountInfo(action.payload.account)
  Storage.Save(`${CookieName}Account`, action.payload.account)
  return newState
}

actions[actiontypes.CurrentSession.UpdateAccount] = (state, action) => {
  let newState = _.merge({}, state)
  const { payload: newData = {} } = action
  const updateAccount = _.merge({}, newState.Account, newData)
  newState.Account = new AuthAccountInfo(updateAccount)
  Storage.Save(`${CookieName}Account`, updateAccount)
  return newState
}

actions[actiontypes.CurrentSession.ClearAccount] = (state, action) => {
  let newState = _.merge({}, state)
  newState.Token = ''
  Storage.Save(`${CookieName}Token`, '')
  newState.Account = new AuthAccountInfo()
  Storage.Save(`${CookieName}Account`, null)
  return newState
}

actions[actiontypes.CurrentSession.ClearSettings] = (state, action) => {
  let newState = _.merge({}, state)
  newState.Settings = {}
  return newState
}

actions[actiontypes.CurrentSession.SetSettings] = (state, action) => {
  let newState = _.merge({}, state)

  const newSettings = action.payload.newSettings || []
  let settings = {}

  if (action.payload.keepExisting === true) {
    settings = newSettings.Settings || {}
  }

  if (newSettings.length > 0) {
    _.each(newSettings, (ns) => {
      if (ns.Name) {
        settings[ns.Name] = ns.Value
      }
    })
  }

  newState.Settings = settings
  return newState
}

export default (
  state = {
    Token: Storage.Get(`${CookieName}Token`) || '',
    Account: new AuthAccountInfo(Storage.Get(`${CookieName}Account`)),
    Settings: {}
  }, action) => {
  if (_.startsWith(action.type, actiontypes.CurrentSession.Prefix)) {
    return actions[action.type](state, action)
  } else {
    return state
  }
}
